module.exports = __webpack_public_path__ + "static/media/avatar-couple.d0e66c99.svg";